import axios from "axios";
const qs = require("qs");
import { setToken, getShowPreference, setRefreshToken } from "./tokenCheck";
// import router from "../router";
import store from "../store/index";
import jwt_decode from "jwt-decode";

const currentURL = window.location.href;

const request = axios.create({
  // baseURL: "http://127.0.0.1:8000/",
  baseURL:
    // "http://127.0.0.1:8000/",
    // "https://9vrcuz6g0c.execute-api.ap-south-1.amazonaws.com/dev-ass/recruitment/", // Dev Gateway
    // "https://ablrb41ade.execute-api.ap-south-1.amazonaws.com/trial/recruitment/", // Staging gateway
    "https://gateway.hire3x.com/recruitment/", // Production gateway
  // "http://10.10.12.97:8000/", // Local Server
});

const tetrisURL = axios.create({
  // baseURL:"http://localhost:5000/"
  // baseURL: "https://tetris-api.simplifymycareer.com",
  baseURL: "https://tetris-api.hire3x.com",
});
const atsPreview = axios.create({
  // baseURL: "https://puppeteer.simplifymycareer.com/", // Staging & Development
  baseURL: "https://puppeteer.hire3x.com/", // Staging & Development
  // "https://auth.hire3x.com/" // Production
});
const converter = axios.create({
  // baseURL: "https://convert.simplifymycareer.com/",
  baseURL: "https://convert.hire3x.com/",
});

const requestRegistration = axios.create({
  baseURL: "https://recruitment-api.hire3x.com",
});
const requestVcclRegistration = axios.create({
  baseURL:
    // "https://vcclbackend.simplifycv.com", // Dev
    // "https://vcclbackend.simplifymycareer.com", // Staging
    "https://vcclbackend.hire3x.com", // Staging
});

const websiteRequest = axios.create({
  // baseURL: "https://api-website.simplifymycareer.com",
  baseURL: "https://api-website.hire3x.com",
});

websiteRequest.interceptors.request.use(
  (config) => {
    config.headers["Authorization"] = "Bearer " + getToken();
    config.headers["userID"] = getProcessedToken();
    // config.headers["userID"] = "5b935330-0f65-4492-b158-5e3e7b9b8bd4";
    // config.headers["userID"] = "e562e893-3ed8-4073-9576-10373bc3e260";

    return config;
  },
  (error) => {
    // Do something with request error
    return error;
  }
);
// const requestBgv = axios.create({
//   baseURL:
//     // "https://recruitment-api.simplifycv.com/", // Dev Gateway
//     "https://recruitment-api.simplifymycareer.com/", // Staging gateway
// });
const requestSuggestion = axios.create({
  // baseURL: "https://suggestions.simplifycv.com/", // Dev Gateway
  // baseURL: "https://suggestions.simplifymycareer.com/", // Staging gateway
  baseURL: "https://suggestions.hire3x.com/", // production gateway
});

const requestrbac = axios.create({
  baseURL:
    // "https://9vrcuz6g0c.execute-api.ap-south-1.amazonaws.com/dev-ass/rbac/access/", // Dev Gateway
    // " https://ablrb41ade.execute-api.ap-south-1.amazonaws.com/trial/rbac/access/", // Staging gateway
    "https://gateway.hire3x.com/rbac/access/", // Production gateway
  // baseURL: "http://rbac.simplifymycareer.com/access/access/",
  // baseURL: "http://127.0.0.1:8002/access/",
});

const KeycloakAPIs = axios.create({
  baseURL:
    // "http://keynode.simplifycv.com/", // Development
    // "https://keynode.simplifymycareer.com/", // Staging
    "https://keynode.hire3x.com/", // Production
});

const assessmentRequest = axios.create({
  baseURL:
    // "https://9vrcuz6g0c.execute-api.ap-south-1.amazonaws.com/dev-ass/assessment/", // Developent Gateway
    // "http://api.judge.simplifycv.com/lis/"  // Developent Endpoint

    // "https://ablrb41ade.execute-api.ap-south-1.amazonaws.com/trial/assessment/", // Staging Gateway
    // "https://assesment-api.simplifymycareer.com/lis/"  // Staging Endpoint

    "https://gateway.hire3x.com/assessment/", // Production gateway

  // "http://127.0.0.1:8000/lis/" // Local Server
});
const SSOService = axios.create({
  baseURL:
    //  "https://auth.simplifymycareer.com/", // Staging & Development
    "https://auth.hire3x.com/", // Production
});

// Getting Microsoft Teams Token
const teamService = axios.create({
  baseURL: "https://keynode.hire3x.com/", // Development
});

const jobRegistration = axios.create({
  baseURL:
    // "https://recruitment-api.simplifycv.com/", // Dev Gateway
    // "https://recruitment-api.simplifymycareer.com/", // Staging
    "https://recruitment-api.hire3x.com/", // Production
});

const jobAuthRegistration = axios.create({
  // baseURL: "https://recruitment-api.simplifycv.com/", // Dev Gateway
  // baseURL: "https://recruitment-api.simplifymycareer.com/", // Staging
  baseURL: "https://recruitment-api.hire3x.com/", // Production
});

const serviceUploadResume = axios.create({
  baseURL: "https://resumeparser.hire3x.com/",
});
const ServiceCandidate = axios.create({
  baseURL:
    // "http://localhost:8000/candidate/", // Development
    // "https://9vrcuz6g0c.execute-api.ap-south-1.amazonaws.com/dev-ass/candidate/", // Dev Gateway
    // "https://ablrb41ade.execute-api.ap-south-1.amazonaws.com/trial/candidate", // Staging
    "https://gateway.hire3x.com/candidate/", // production
});

const ServiceAuthCandidate = axios.create({
  baseURL:
    // "http://localhost:8000/candidate/", // Development
    // "https://candidate-api.simplifycv.com/", // Dev Gateway
    // "https://candidate-api.simplifymycareer.com/", // Dev Gateway
    "https://candidate-api.hire3x.com/", // Prod Gateway
  // "https://ablrb41ade.execute-api.ap-south-1.amazonaws.com/trial/candidate", // Staging
});

const notificationAuth = axios.create({
  // baseURL: "https://notification.simplifycv.com/", // Dev Gateway
  // baseURL: "https://notification.simplifymycareer.com/", // Staging
  baseURL: "https://notification.hire3x.com/", // Production
});
function getProcessedToken() {
  var decoded = jwt_decode(
    localStorage.getItem("vue_token") || localStorage.getItem("accessToken")
  );
  return decoded.sub;
}

function getLoggedInUserEmail() {
  let decoded = jwt_decode(getToken());
  return decoded.email;
}

// request
request.interceptors.request.use(
  (config) => {
    config.headers["Authorization"] = "Bearer " + getToken();
    // config.headers["userID"] = getProcessedToken();
    return config;
  },
  (error) => {
    // Do something with request error
    return error;
  }
);
tetrisURL.interceptors.request.use(
  (config) => {
    config.headers["userID"] = getProcessedToken();
    return config;
  },
  (error) => {
    return error;
  }
);
requestVcclRegistration.interceptors.request.use(
  (config) => {
    config.headers["userID"] = "946a70ae-6352-4608-a0c8-641a9b23158d";

    return config;
  },
  (error) => {
    // Do something with request error
    return error;
  }
);
requestVcclRegistration.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    // Do something with request error

    return error.response;
  }
);
requestRegistration.interceptors.request.use(
  (config) => {
    config.headers["userID"] = "d3dd60f4-041c-4b56-8583-ce620a6be06c";
    // config.headers["userID"] = getProcessedToken();
    // config.headers["userID"] = "5b935330-0f65-4492-b158-5e3e7b9b8bd4";
    // config.headers["userID"] = "e562e893-3ed8-4073-9576-10373bc3e260";

    return config;
  },
  (error) => {
    // Do something with request error
    return error;
  }
);
requestRegistration.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    // Do something with request error

    return error.response;
  }
);
jobAuthRegistration.interceptors.request.use(
  (config) => {
    config.headers["userID"] = "d3dd60f4-041c-4b56-8583-ce620a6be06c";
    console.log(config);
    return config;
  },
  (error) => {
    // Do something with request error
    return error;
  }
);
jobAuthRegistration.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    // Do something with request error

    return error.response;
  }
);

ServiceAuthCandidate.interceptors.request.use(
  (config) => {
    config.headers["userID"] = "d3dd60f4-041c-4b56-8583-ce620a6be06c";
    console.log(config);
    return config;
  },
  (error) => {
    // Do something with request error
    return error;
  }
);
ServiceAuthCandidate.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    // Do something with request error

    return error.response;
  }
);

//response
request.interceptors.response.use((response) => {
  return response;
});
//response
request.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    // Do something with request error
    if (
      error.response == undefined ||
      error.response.status == 403 ||
      error.response.status == 401
    ) {
      await refreshAccessToken();
      error.config.headers["Authorization"] = "bearer " + getToken();
      return axios(error.config);
    } else {
      return error.response;
    }
  }
);

//request
requestSuggestion.interceptors.request.use(
  (config) => {
    // config.headers["Authorization"] = "Bearer " + getToken();
    config.headers["userID"] = getProcessedToken();
    return config;
  },
  (error) => {
    // Do something with request error
    return error;
  }
);

//response
requestSuggestion.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    // Do something with request error
    if (
      error.response == undefined ||
      error.response.status == 403 ||
      error.response.status == 401
    ) {
      await refreshAccessToken();
      error.config.headers["Authorization"] = "bearer " + getToken();
      return axios(error.config);
    } else {
      return error.response;
    }
  }
);

// For AccessPanel
requestrbac.interceptors.request.use(
  (config) => {
    config.headers["Authorization"] = "Bearer " + getToken();
    // config.headers["userID"] = getProcessedToken();
    return config;
  },
  (error) => {
    // Do something with request error

    Promise.reject(error);
  }
);

//  AccessPanel To get new Token using Refresh token
requestrbac.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    // Do something with request error
    if (
      error.response == undefined ||
      error.response.status == 403 ||
      error.response.status == 401
    ) {
      await refreshAccessToken();
      error.config.headers["Authorization"] = "bearer " + getToken();
      return axios(error.config);
    } else {
      return error.response;
    }
  }
);

// For Assessment license
assessmentRequest.interceptors.request.use(
  (config) => {
    config.headers["Authorization"] = "Bearer " + getToken();

    return config;
  },
  (error) => {
    // Do something with request error
    Promise.reject(error);
  }
);

//  Assessment To get new Token using Refresh token
assessmentRequest.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    // Do something with request error
    if (
      error.response == undefined ||
      error.response.status == 403 ||
      error.response.status == 401
    ) {
      await refreshAccessToken();
      error.config.headers["Authorization"] = "bearer " + getToken();
      return axios(error.config);
    } else {
      return error.response;
    }
  }
);

ServiceCandidate.interceptors.request.use(
  (config) => {
    config.headers["Authorization"] = "Bearer " + getToken();

    return config;
  },
  (error) => {
    // Do something with request error
    Promise.reject(error);
  }
);

//  ReportsTo get new Token using Refresh token
ServiceCandidate.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    // Do something with request error
    if (
      error.response == undefined ||
      error.response.status == 403 ||
      error.response.status == 401
    ) {
      await refreshAccessToken();
      error.config.headers["Authorization"] = "bearer " + getToken();
      return axios(error.config);
    } else {
      return error.response;
    }
  }
);

// For AccessPanel
// requestBgv.interceptors.request.use(
//   (config) => {
//     config.headers["userID"] = getProcessedToken();
//     return config;
//   },
//   (error) => {
//     // Do something with request error

//     Promise.reject(error);
//   }
// );
// For Device Activity
KeycloakAPIs.interceptors.request.use(
  (config) => {
    config.headers["Authorization"] = "Bearer " + getToken();

    config.headers["userID"] = getProcessedToken();

    return config;
  },

  (error) => {
    // Do something with request error

    return error;
  }
);

//  AccessPanel To get new Token using Refresh token
// requestBgv.interceptors.response.use(
//   (response) => {
//     return response;
//   },
//   async (error) => {
//     // Do something with request error
//     if (
//       error.response == undefined ||
//       error.response.status == 403 ||
//       error.response.status == 401
//     ) {
//       await getNewAccessToken();
//       error.config.headers["Authorization"] = "bearer " + getToken();
//       return axios(error.config);
//     } else {
//       return error.response;
//     }
//   }
// );
serviceUploadResume.interceptors.request.use(
  (config) => {
    config.headers["userID"] = getProcessedToken();
    return config;
  },
  (error) => {
    // Do something with request error

    Promise.reject(error);
  }
);

// Get token from localstorage
const getToken = () => {
  let data = document.cookie.split(";");
  for (let i in data) {
    let cur = data[i].split("=");
    if (cur[0].trim() === "accessToken") {
      return cur[1];
    }
  }
  // return localStorage.getItem("vue_token");
};

const getRefreshToken = () => {
  let data = document.cookie.split(";");
  for (let i in data) {
    let cur = data[i].split("=");
    if (cur[0].trim() === "refreshToken") {
      return cur[1];
    }
  }
  return null;
};

// Getting new Access token using Refresh token
const getNewAccessToken = async () => {
  // const authDataRefreshToken = store.getters["userVUEX/getUserRefreshToken"];
  let panel =
    getShowPreference().type == "panel" ? "panel-login" : "vue-test-app";
  console.log(panel);
  let payload = qs.stringify({
    grant_type: "refresh_token",
    client_id: panel,
    refresh_token: getRefreshToken(),
  });

  try {
    const response = await axios({
      method: "post",
      url:
        // "https://auth.simplifymycareer.com/auth/realms/hire3x-dev/protocol/openid-connect/token", // Dev
        // "https://auth.simplifymycareer.com/auth/realms/SimplifyCV/protocol/openid-connect/token", // Staging
        "https://auth.hire3x.com/auth/realms/SimplifyCV/protocol/openid-connect/token", // Production
      data: payload,
      headers: {
        "content-type": "application/x-www-form-urlencoded;charset=utf-8",
      },
    });

    setToken(response.data.access_token);
    setRefreshToken(response.data.refresh_token);
    localStorage.setItem("accessToken", response.data.access_token);
    console.log("new token");
    store.commit("userVUEX/SET_TOKEN", response.data.access_token);
    if (response.status == 400) {
      localStorage.clear();
      store.dispatch("userVUEX/LogOut");
    }
  } catch (error) {
    localStorage.clear();
    store.dispatch("userVUEX/LogOut");
  }
};

// Refresh Google access token using the backend endpoint
export const refreshGoogleToken = async () => {
  const refreshToken = getRefreshToken();

  try {
    const response = await ServiceCandidate.post("/can/auth/google-refresh/", {
      refresh_token: refreshToken,
    });

    if (response.data.type === "Success") {
      const tokens = response.data.data;
      setToken(tokens.id_token);
      localStorage.setItem("accessToken", tokens.id_token);
      store.commit("userVUEX/SET_TOKEN", tokens.id_token);
      // Note: Google doesn't return a new refresh_token on refresh, so we keep the existing one
    } else {
      localStorage.clear();
      store.dispatch("userVUEX/LogOut");
    }
  } catch (error) {
    if (
      axios.isCancel(error) ||
      ["ECONNABORTED", "ERR_CANCELED"].includes(error.code)
    ) {
      return;
    }
    localStorage.clear();
    store.dispatch("userVUEX/LogOut");
  }
};

// Unified function to refresh access token based on login type
export const refreshAccessToken = async () => {
  const loginData = getShowPreference();
  if (loginData && loginData.logged_in === "google") {
    // User logged in via Google - use Google refresh endpoint
    await refreshGoogleToken();
  } else {
    // User logged in via Keycloak - use existing refresh flow
    await getNewAccessToken();
  }
};

export {
  request,
  websiteRequest,
  tetrisURL,
  currentURL,
  atsPreview,
  converter,
  serviceUploadResume,
  requestrbac,
  KeycloakAPIs,
  ServiceCandidate,
  ServiceAuthCandidate,
  assessmentRequest,
  SSOService,
  teamService,
  jobRegistration,
  jobAuthRegistration,
  requestSuggestion,
  requestRegistration,
  requestVcclRegistration,
  getLoggedInUserEmail,
  getNewAccessToken,
  notificationAuth,
};
